import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Hanger = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        d="M21.6003 18.1992L13.0003 11.7492V10.8392C14.6503 10.3492 15.8003 8.66918 15.4303 6.78918C15.1703 5.47918 14.1303 4.38918 12.8203 4.08918C10.5403 3.56918 8.50026 5.29918 8.50026 7.49918H10.5003C10.5003 6.66918 11.1703 5.99918 12.0003 5.99918C12.8303 5.99918 13.5003 6.66918 13.5003 7.49918C13.5003 8.33918 12.8103 9.01918 11.9703 8.99918C11.4303 8.98918 11.0003 9.44918 11.0003 9.98918V11.7492L2.40026 18.1992C1.63026 18.7792 2.04026 19.9992 3.00026 19.9992H12.0003H21.0003C21.9603 19.9992 22.3703 18.7792 21.6003 18.1992ZM6.00026 17.9992L12.0003 13.4992L18.0003 17.9992H6.00026Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Hanger;
